import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowTopBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M7.25011 2.68945L12.3108 7.75011L11.2501 8.81077L8.00011 5.56077V21.0001H6.50011V5.56077L3.25011 8.81077L2.18945 7.75011L7.25011 2.68945ZM17.5001 3.00011V18.4395L20.7501 15.1895L21.8108 16.2501L16.7501 21.3108L11.6895 16.2501L12.7501 15.1895L16.0001 18.4395V3.00011H17.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTopBottom;
